import { useContext } from 'react';
import { PriorityChartsDataContext } from '../contexts/PriorityChartsDataContext';

export const usePriorityChartsDataContext = () => {
    return useContext(PriorityChartsDataContext);
};
